if (!customElements.get('ingredient-slider')) {
  class IngredientSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.isReady = false;
    }

    connectedCallback() {
      this.swiperEl = this.querySelector('.produktinhaltsstoffe__slider');
      this.tabsContainer = this.querySelector('.produktinhaltsstoffe__tabs');
      this.tabs = this.querySelectorAll('.produktinhaltsstoffe__tab');
      this.prevButton = this.querySelector('[data-direction="prev"]');
      this.nextButton = this.querySelector('[data-direction="next"]');
      this.isReady = false;
      this.initSwiper();
    }

    disconnectedCallback() {
      this.isReady = false;

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSwiper() {
      if (!this.isConnected) {
        return;
      }

      if (typeof Swiper === 'undefined' || !this.swiperEl) {
        window.requestAnimationFrame(() => this.initSwiper());
        return;
      }

      if (this.swiper) {
        return;
      }

      const desktopColumns = Number.parseInt(this.dataset.desktopColumns, 10) || 4;
      const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
      const loopEnabled = slideCount > desktopColumns;

      const options = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 400,
        slidesPerGroup: 1,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        loop: loopEnabled,
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          768: {
            slidesPerView: desktopColumns,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
        on: {
          init: (swiper) => {
            this.setActiveTab(swiper.realIndex);
            window.requestAnimationFrame(() => {
              if (this.isConnected && this.swiper) {
                this.isReady = true;
              }
            });
          },
          slideChange: (swiper) => this.onSlideChanged(swiper),
        },
      };

      if (this.prevButton && this.nextButton) {
        options.navigation = {
          prevEl: this.prevButton,
          nextEl: this.nextButton,
        };
      }

      this.swiper = new Swiper(this.swiperEl, options);
      this.setupTabs();
    }

    setupTabs() {
      for (const tab of this.tabs) {
        tab.addEventListener('click', () => {
          const index = Number.parseInt(tab.dataset.index, 10);

          if (!this.swiper || Number.isNaN(index)) {
            return;
          }

          if (this.swiper.params.loop) {
            this.swiper.slideToLoop(index);
            return;
          }

          this.swiper.slideTo(index);
        });
      }
    }

    onSlideChanged(swiper) {
      const index = swiper.realIndex;
      this.setActiveTab(index);

      if (!this.isReady) {
        return;
      }

      this.scrollTabIntoView(this.tabs[index]);
    }

    setActiveTab(index) {
      for (let i = 0; i < this.tabs.length; i++) {
        this.tabs[i].classList.toggle('produktinhaltsstoffe__tab--active', i === index);
      }
    }

    scrollTabIntoView(tab) {
      if (!this.tabsContainer || !tab) {
        return;
      }

      const container = this.tabsContainer;
      const tabRect = tab.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const target =
        container.scrollLeft + (tabRect.left - containerRect.left) - (container.clientWidth - tabRect.width) / 2;

      container.scrollTo({
        left: Math.max(0, target),
        behavior: 'smooth',
      });
    }
  }

  customElements.define('ingredient-slider', IngredientSlider);
}